/**
 * CL-INVOICE-001A3F — Designer/Collaborator portal sign-out sequence.
 * Order is intentional: await Firebase signOut before clearing session or navigating.
 */

export const CLIENT_PORTAL_LOGIN_PATH = "/client-portal";

/**
 * @param {object} deps
 * @param {() => Promise<unknown>} deps.signOutFn
 * @param {() => void} [deps.clearInvoiceSession]
 * @param {() => void} [deps.clearAuthSession]
 * @param {(to: string, opts?: { replace?: boolean }) => void} deps.navigate
 * @param {string} [deps.loginPath]
 * @returns {Promise<{ ok: true } | { ok: false, message: string }>}
 */
export async function runClientPortalSignOutSequence({
  signOutFn,
  clearInvoiceSession = () => {},
  clearAuthSession = () => {},
  navigate,
  loginPath = CLIENT_PORTAL_LOGIN_PATH,
} = {}) {
  if (typeof signOutFn !== "function") {
    return { ok: false, message: "Sign out is unavailable." };
  }
  if (typeof navigate !== "function") {
    return { ok: false, message: "Navigation is unavailable." };
  }

  try {
    await signOutFn();
  } catch (error) {
    const message =
      (error && typeof error === "object" && error.message) ||
      "Sign out failed. You are still signed in.";
    return { ok: false, message: String(message) };
  }

  try {
    clearInvoiceSession();
  } catch {
    /* session clear is best-effort after auth is gone */
  }
  try {
    clearAuthSession();
  } catch {
    /* same */
  }

  navigate(loginPath, { replace: true });
  return { ok: true };
}
